import { isNil } from 'lodash'

// Audit-drawer formatters. Null → em dash so a missing metric reads as "no
// value" rather than "0". (Timestamps use the app-wide `formatTime` from
// `@/utils/helpers`; the seconds→HH:MM:SS `formatDuration` there is unrelated to
// these ms latencies, hence `formatMs`.)

export const formatMs = (ms) => {
  if (isNil(ms)) return '—'
  return ms >= 1000 ? `${(ms / 1000).toFixed(ms % 1000 === 0 ? 0 : 1)}s` : `${ms}ms`
}

export const formatNumber = (n) => (isNil(n) ? '—' : n.toLocaleString())

export const formatCost = (cost) => (isNil(cost) ? '—' : `$${cost.toFixed(4)}`)
